import { render, staticRenderFns } from "./CGA.vue?vue&type=template&id=547e6eec&scoped=true&"
import script from "./CGA.vue?vue&type=script&lang=js&"
export * from "./CGA.vue?vue&type=script&lang=js&"
import style0 from "./CGA.vue?vue&type=style&index=0&id=547e6eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e6eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547e6eec')) {
      api.createRecord('547e6eec', component.options)
    } else {
      api.reload('547e6eec', component.options)
    }
    module.hot.accept("./CGA.vue?vue&type=template&id=547e6eec&scoped=true&", function () {
      api.rerender('547e6eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/CGA.vue"
export default component.exports